const removeAllCartItemsAction = () => ({
    type: "remove_all_cart_items"
})

export default removeAllCartItemsAction;